module.exports = __webpack_public_path__ + "img/login-v5.3e6809ae.png";